module.exports = __webpack_public_path__ + "img/btn_ka.8121783.webp";